var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OrderDocumentList',{attrs:{"order":_vm.order},on:{"documentsCreated":_vm.onEventDocumentsCreated}})}
var staticRenderFns = []

export { render, staticRenderFns }